<template>
  <div>
    <v-select
      v-model="selected"
      :items="items"
      item-text="name"
      item-value="value"
      :label="$t('dangerousGoods.dangerousGoodsList.form.fss7Relevant')"
      :hint="autoHint"
      :persistent-hint="!!autoHint"
      data-cy="fss7Relevant"
      dense
    ></v-select>
  </div>
</template>
<script>
import { hasCriticalHazardCode } from "../../../data/criticalHazardCodes";

export default {
  props: ["value"],
  computed: {
    items() {
      return [
        { name: this.$t("general.yes"), value: true },
        { name: this.$t("general.no"), value: false },
      ];
    },
    selected: {
      get() {
        return !!this.value.fss7Relevant;
      },
      set(val) {
        this.value.fss7Relevant = val;
      },
    },
    hasCritical() {
      return hasCriticalHazardCode(this.value?.h);
    },
    autoHint() {
      return this.hasCritical
        ? this.$t("dangerousGoods.dangerousGoodsList.form.fss7AutoHint")
        : "";
    },
  },
  watch: {
    //adding one of the critical H codes pre-fills YES; the user stays free to
    //set it back to NO afterwards
    hasCritical(isCritical, wasCritical) {
      if (isCritical && !wasCritical) {
        this.value.fss7Relevant = true;
      }
    },
  },
};
</script>
